var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExpandPanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9H14C14.5523 9 15 9.4477 15 10V13C15 13.5523 14.5523 14 14 14H8.5C7.9477 14 7.5 13.5523 7.5 13V10C7.5 9.4477 7.9477 9 8.5 9ZM4 8V6.207L6.14655 8.3535L6.85355 7.6465L4.70705 5.5H6.5V4.5H3V8H4ZM6.5 11H2C1.448 10.9993 1.00065 10.552 1 10V3.5C1.00055 2.94795 1.44795 2.50055 2 2.5H13C13.552 2.50065 13.9993 2.948 14 3.5V8H13V3.5H2V10H6.5V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpandPanel);
export default __webpack_public_path__ + "static/media/ic-expand-panel.70c80c558106a7a705c05ad0d22c3dfd.svg";
export { ForwardRef as ReactComponent };